import { userIsGranted } from './auth/authorized';

const Auth = { userIsGranted };

export { Auth };
